import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { useLang } from "../i18n";
import { api } from "../lib/api";

const L = {
  de: { checking: "Zahlung wird geprüft…", paid: "Vielen Dank! Deine Vorbestellung ist bestätigt.", pending: "Zahlung noch ausstehend. Bitte kurz warten oder Seite neu laden.", cancel: "Vorbestellung abgebrochen. Kein Betrag wurde belastet.", back: "Zurück zu den Drops", home: "Zur Startseite", expired: "Prüfung dauert länger als erwartet – bitte später erneut prüfen." },
  en: { checking: "Verifying payment…", paid: "Thank you! Your pre-order is confirmed.", pending: "Payment still pending. Please wait a moment or reload.", cancel: "Pre-order cancelled. No amount was charged.", back: "Back to drops", home: "To home", expired: "Verification is taking longer than expected – please check again later." },
};

export function PaymentSuccess() {
  const { lang } = useLang();
  const t = L[lang];
  const [params] = useSearchParams();
  const [state, setState] = useState("checking");

  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) { setState("pending"); return; }
    let tries = 0;
    const poll = async () => {
      tries += 1;
      try {
        const r = await api.get(`/payments/status/${sid}`);
        if (r.data.payment_status === "paid") { setState("paid"); return; }
        if (["failed", "expired"].includes(r.data.status)) { setState("pending"); return; }
      } catch { /* ignore */ }
      if (tries >= 6) { setState("expired"); return; }
      setTimeout(poll, 2000);
    };
    poll();
  }, [params]);

  return (
    <div className="mx-auto max-w-md px-4 py-24 text-center">
      {state === "checking" && <Loader2 size={40} className="mx-auto text-sonne animate-spin" data-testid="pay-checking" />}
      {state === "paid" && <CheckCircle2 size={48} className="mx-auto text-ready" data-testid="pay-paid" />}
      {(state === "pending" || state === "expired") && <Loader2 size={40} className="mx-auto text-sonne" data-testid="pay-pending" />}
      <p className="mt-5 text-lg text-wachs">
        {state === "checking" ? t.checking : state === "paid" ? t.paid : state === "expired" ? t.expired : t.pending}
      </p>
      <div className="mt-6 flex justify-center gap-3">
        <Link to="/drops" className="border border-bronze/40 text-bronze-soft px-5 py-2.5 rounded-md hover:bg-bronze/10">{t.back}</Link>
        <Link to="/" className="bg-sonne text-nacht font-medium px-5 py-2.5 rounded-md">{t.home}</Link>
      </div>
    </div>
  );
}

export function PaymentCancel() {
  const { lang } = useLang();
  const t = L[lang];
  return (
    <div className="mx-auto max-w-md px-4 py-24 text-center">
      <XCircle size={48} className="mx-auto text-wachs-dim" data-testid="pay-cancel" />
      <p className="mt-5 text-lg text-wachs">{t.cancel}</p>
      <Link to="/drops" className="mt-6 inline-block bg-sonne text-nacht font-medium px-5 py-2.5 rounded-md">{t.back}</Link>
    </div>
  );
}
